import { render, staticRenderFns } from "./createDigitalResource.vue?vue&type=template&id=04f5ceda&"
import script from "./createDigitalResource.vue?vue&type=script&lang=js&"
export * from "./createDigitalResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports